import { HttpErrorResponse } from '@angular/common/http';
import { CodigoEstadoHTTP } from 'src/app/pago/enums/CodigosEstadosHTTP.enum';

export const retryRequest = (error: HttpErrorResponse): boolean => {
  const errorsCommons = [
    CodigoEstadoHTTP.UNAUTHORIZED,
    CodigoEstadoHTTP.FORBIDDEN,
    CodigoEstadoHTTP.TIME_OUT,
    CodigoEstadoHTTP.SERVICE_UNAVAILABLE,
  ];
  const errorServer = [CodigoEstadoHTTP.INTERNAL_SERVER_ERROR];

  if (errorsCommons.includes(error.status)) {
    return true;
  }
  if (errorServer.includes(error.status)) {
    return !Array.isArray(error.error);
  }
  return false;
};
